export default __webpack_public_path__ + "images/Transventricular_View_dark.b239565436126678364917f314d9e860.png";